import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { getSupplierPublicInquiryAction } from '../../../../modules/inquiries/suppliers/public/Actions';
import {
  inquiryByIdSelector,
  supplierPublicInquiriesIsLoadingSelector
} from '../../../../modules/inquiries/suppliers/public/Selectors';
import {
  getSinglePendingPublicSupplierInquiryAction,
  moderateCreateSupplierPublicAction,
  updatePendingPublicInquiryAction,
  getPendingPublicInquiriesAction
} from '../../../../modules/supplierModeration/publicInquiry/Actions';
import {
  pendingSuppliersPublicInquiryIsLoadingSelector,
  pendingSupplierPublicInquiryByIdSelector
} from '../../../../modules/supplierModeration/publicInquiry/Selectors';

import { InputField, TextArea, Upload } from '../../../../components/form/';
import { useHistory } from 'react-router-dom';

import ModerationForm from '../../../../components/form/ModerationForm';
import api from '../../../../helpers/api';
import { push } from 'react-router-redux';
import getLangData from '../../../../utils/getLangData';

const ViewPublicInquiry = props => {
  const {
    isLoading,
    pendingIsLoading,
    moderateCreateSupplierPublicInquiry,
    inquiryID,
    moderationId,
    inquiry,
    getPublicInquiry,
    updatePendingPublicInquiry,
    getPublicInquiries,
    match
  } = props;
  let history = useHistory();
  const lang = getLangData().fields
  const [inquryData, setInquryData] = useState({});
  const id = match?.params?.id;
  useEffect(() => {
    // getPublicInquiry(inquiryID);
    // getPublicInquiries()
    if (id) {
      getSinglePropsal(id);
    }
  }, [id]);

  const getSinglePropsal = async inqId => {
    try {
      const { data } = await api.get(
        `public-supplier-staging-proposals/${inqId}`
      );
      setInquryData(data);
    } catch (error) {
      setInquryData({});
    }
  };

  const moderate = async proposalId => {
    try {
      await api.post(`public-supplier-staging-proposals/moderate/`, {
        proposalId
      });
      window.location.href = '/suppliers-moderation/public-proposal';
    } catch (error) {
      setInquryData({});
    }
  };
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...inquryData }}
      onSubmit={values => {
        moderate(id);
      }}
    >
      {({ handleSubmit }) => (
        <ModerationForm
          handleSubmit={handleSubmit}
          heading={lang.view_pending_public_inquiry}
          isLoading={isLoading || pendingIsLoading}
        >
          <InputField name='price' label={lang.price} />

          <TextArea name='message' label={lang.message} />
          {/* <InputField name='attachment' label='attachment' /> */}
          <Upload
            data={{ userID: 'customerId' }}
            name='attachment'
            label={`${lang.inquiry_image} :'`}
            S3Bucket='warshatna-users'
            // API="customer/customer-category-image-signedurl/"
            API='users/user-profile-image-signedurl'
          />
        </ModerationForm>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: pendingSupplierPublicInquiryByIdSelector(state, inquiryID),
    // isLoading: supplierPublicInquiriesIsLoadingSelector(state),
    pendingIsLoading: pendingSuppliersPublicInquiryIsLoadingSelector(state)
  };
};

const mapDispatchToProps = {
  getPublicInquiry: getSinglePendingPublicSupplierInquiryAction,
  moderateCreateSupplierPublicInquiry: moderateCreateSupplierPublicAction,
  getPublicInquiries: getPendingPublicInquiriesAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPublicInquiry);
